export default __webpack_public_path__ + "202ed7d1d8d71ebc8bef3eb412093f29.png";